import React from 'react';
import { LoginLayout } from 'components/layouts/LoginLayout';
import { ReinitialiserContent } from 'components/organisms/Contents/ReinitialiserContent';

const Reinitialiser = ({ match }) => {
  return (
    <LoginLayout>
      <ReinitialiserContent match={match} />
    </LoginLayout>
  );
};
export default Reinitialiser;
